require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./container"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./container"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./container")) : factory(root["./utils"], root["./container"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__15__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[24],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-flexLayout{display:flex}.ba-common-flexLayout.is-fullHeight{height:100%}.ba-common-flexLayout__sw{position:absolute;top:0;left:0;right:0;bottom:0}.ba-common-flexLayout-item{min-width:0;min-height:0;max-width:100%}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.ba-common-flexLayout-item{max-width:100%}}", ""]);

// exports


/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(319);


/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;

var _FlexLayout = _interopRequireWildcard(__webpack_require__(320));

exports.default = _FlexLayout.default;
exports.FlexLayout = _FlexLayout.default;
exports.FlexItem = _FlexLayout.FlexItem;

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.FlexItem = exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _container = _interopRequireDefault(__webpack_require__(15));

var _utils = __webpack_require__(5);

__webpack_require__(321);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  sanitize
} = _utils.propsUtils;

class FlexLayout extends _react.Component {
  // eslint-disable-line no-underscore-dangle
  render() {
    const {
      className,
      style,
      fullHeight,
      direction,
      alignItems,
      children,
      wrap,
      justifyContent,
      inline,
      width,
      height,
      minHeight,
      minWidth,
      maxHeight,
      maxWidth,
      outer,
      outerClassName,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)('ba-common-flexLayout', {
      fullHeight
    });
    const styles = { ...style,
      flexDirection: direction,
      flexWrap: wrap,
      alignItems,
      justifyContent,
      width,
      height,
      minHeight,
      minWidth,
      maxHeight,
      maxWidth
    };
    const inner = fullHeight ? _react.default.Children.map(children, child => child && child.type && child.type.__FlexItem__ // eslint-disable-line no-underscore-dangle
    ? _react.default.cloneElement(child, {
      rowLayout: direction === 'row' || direction === 'row-reverse',
      fullHeightLayout: true
    }) : child) : children;
    const display = inline ? 'inline-flex' : 'flex';

    if ((direction == null || direction === 'row' || direction === 'row-reverse') && alignItems != null) {
      // The following is specifically to fix IE11 layout issues with align items inside a row flex layout.
      // IE 11 does not correctly align items unless the flex layout has a fixed height.
      // To get around this we create a column layout and align the items vertically inside it.
      const outerStyle = {
        display,
        maxWidth: '100%',
        flexDirection: 'column',
        justifyContent: alignItems
      };

      if (inline) {
        outerStyle.verticalAlign = 'middle';
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        style: outerStyle,
        className: outerClassName
      }, outer, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, FlexLayout), {
        className: `${classNames} ${className}`,
        style: { ...styles
        }
      }), inner));
    }

    styles.display = display;

    if (inline) {
      styles.verticalAlign = 'middle';
    }

    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, FlexLayout), {
      className: `${classNames} ${className}`,
      style: styles
    }), inner);
  }

}

exports.default = FlexLayout;
(0, _defineProperty2.default)(FlexLayout, "propTypes", {
  className: _propTypes.default.string,
  outerClassName: _propTypes.default.string,
  children: _propTypes.default.node,
  fullHeight: _propTypes.default.bool,
  style: _propTypes.default.object,
  direction: _propTypes.default.oneOf(['column', 'row', 'row-reverse', 'column-reverse']),
  alignItems: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline']),
  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  justifyContent: _propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around']),
  inline: _propTypes.default.bool,
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  minWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  minHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  outer: _propTypes.default.element
});
(0, _defineProperty2.default)(FlexLayout, "defaultProps", {
  className: '',
  maxWidth: '100%'
});
(0, _defineProperty2.default)(FlexLayout, "__FlexLayout__", true);

class FlexItem extends _react.Component {
  render() {
    const {
      className,
      style,
      order,
      grow,
      shrink,
      relative,
      alignSelf,
      textAlign,
      basis,
      overflow,
      fullHeightLayout,
      rowLayout,
      simpleContent,
      ...others
    } = this.props;
    let {
      children
    } = this.props;
    const classNames = (0, _utils.classnames)('ba-common-flexLayout-item');
    let flexGrow;

    if (grow === true) {
      flexGrow = 1;
    } else {
      flexGrow = grow > 0 ? grow : 0;
    }

    let flexShrink;

    if (shrink != null) {
      flexShrink = shrink ? 1 : 0;
    } else {
      flexShrink = flexGrow;
    }

    const flexBasis = basis || (grow ? 0 : null);
    const styles = { ...style,
      flexBasis,
      flexGrow,
      flexShrink,
      alignSelf,
      order
    };

    if (relative) {
      styles.position = 'relative';
    } // Work around ancient Safari bug https://bugs.webkit.org/show_bug.cgi?id=137730
    // If a nested child is a flex layout with fullHeight then we need to wrap it.
    // We also need to do this to allow a child components to use a height of 100% without causing
    // the flex layout to grow beyond its bounds.
    // And if a flex layout has direction row and any child flex item nests a flex layout with full height.
    // In this case the flex item should also have a width that's not dependent on the child content. There's several ways
    // to achieve this so we cannot assume to be able to check this case in code here.


    if (children != null && _react.default.Children.count(children) === 1) {
      const child = _react.default.Children.toArray(children).filter(c => c)[0];

      if (child && (!simpleContent && grow && fullHeightLayout || rowLayout && child.type && child.type.__FlexLayout__ && // eslint-disable-line no-underscore-dangle
      child.props.fullHeight)) {
        styles.position = 'relative';
        children = /*#__PURE__*/_react.default.createElement("div", {
          className: "ba-common-flexLayout__sw",
          style: {
            overflow
          }
        }, children);
      } else {
        styles.overflow = overflow;
      }
    } else {
      styles.overflow = overflow;
    }

    return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({}, sanitize(others, FlexItem), {
      className: `${classNames} ${className}`,
      style: styles,
      textAlign: textAlign
    }), children);
  }

}

exports.FlexItem = FlexItem;
(0, _defineProperty2.default)(FlexItem, "propTypes", {
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  grow: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  shrink: _propTypes.default.bool,
  relative: _propTypes.default.bool,
  textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),
  basis: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  overflow: _propTypes.default.string,
  style: _propTypes.default.object,
  fullHeightLayout: _propTypes.default.bool,
  rowLayout: _propTypes.default.bool,
  order: _propTypes.default.number,
  alignSelf: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline']),
  // a means to opt out of the flex layout bug fix
  simpleContent: _propTypes.default.bool
});
(0, _defineProperty2.default)(FlexItem, "defaultProps", {
  className: ''
});
(0, _defineProperty2.default)(FlexItem, "__FlexItem__", true);

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_FlexLayout_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(107);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_FlexLayout_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_FlexLayout_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_FlexLayout_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_FlexLayout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[318,0]]]);
});